import { ThunkedAction } from '../../interfaces/redux.interface';
import httpService from '../../services/http.service';
import * as ClientsAndCompanyActions from '../constants/workingTime';
import { getAuthToken } from '../selectors/login.selectors';

const getClientsAndCompanysSuccess = (payload: any[]) => ({
	type: ClientsAndCompanyActions.GET_CLIENTS_COMPANIES_SUCCESS,
	payload,
});

export const getRepresentUnitId = async () => {
	const selectedUnitId = JSON.parse(sessionStorage.getItem('repDashboardFilters') || '{}')?.unitIds?.[0];
	if (selectedUnitId) {
		return selectedUnitId;
	}
	const units: any = await httpService.api<any[]>({
		type: 'getRepresntUnits',
		query: { pageName: 'repCustomers', 'rep-only': true },
	});
	return units?.[0]?.numericId;
};

export const fetchClientsAndCompanysData = (
	accountantsIds: number[],
): ThunkedAction => {
	console.log(
		'Fetching clients and companies data for accountants: ',
		accountantsIds,
	);

	return async (dispatch, getState) => {
		const token = getAuthToken(getState());
		const unitId = await getRepresentUnitId();
		
		httpService
			.api<any[]>({
				type: 'getClientsSummary',
				query: {
					key: token,
					period: 'monthly',
					year: new Date().getFullYear(),
					month: new Date().getMonth() + 1,
					clientnumbers: accountantsIds.join(','),
					unitIds: unitId,
				},
			})
			.then(data => {
				dispatch(getClientsAndCompanysSuccess(data));
			})
			.catch(() => {});
	};
};
